import { ASSIGNED_DIFFICULTIES, Difficulty } from '@all-for-one/shared-types'
import styles from 'css/components/tables/difficulty-dropdown.module.css'
import downTriangle from 'img/down-triangle-white.svg'
import { difficultyToCssClass } from '@all-for-one/shared-types'


type DifficultyDropdownProps = {
    currentDifficulty: Difficulty,
    handleDifficultyChange: (difficulty: Difficulty) => void
}

export const DifficultyDropdown = ({ currentDifficulty, handleDifficultyChange }: DifficultyDropdownProps) => {
    
    const values: Difficulty[] = [...Object.values(ASSIGNED_DIFFICULTIES), 'Not assigned']
    // console.log('currentDifficulty', currentDifficulty)

    // Handle invalid difficulty values
    const validDifficulty = difficultyToCssClass[currentDifficulty] ? currentDifficulty : 'Not assigned'

    return (
        <select 
            value={validDifficulty}
            onChange={(event) => handleDifficultyChange(event.target.value as Difficulty)}
            className={`${styles.difficultyDropdown} ${styles[difficultyToCssClass[validDifficulty]]}`}
        >
            {values.map((difficulty: Difficulty) => (
                <option 
                    key={difficulty} 
                    value={difficulty}
                    className={styles[difficultyToCssClass[difficulty]]}
                >
                    {difficulty}
                </option>
            ))}
        </select>
    )
}